import api from '../api';

// Push nativo (Web Push) deste aparelho: pede a permissão, inscreve no service worker e registra na API.
const CHAVE_RECUSA = 'rfc_push_recusado_em';
const ESPERA_RECUSA = 30 * 24 * 3600 * 1000; // volta a oferecer em 30 dias

export const suportaPush = () =>
  typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

// Chave VAPID (base64url) no formato que o PushManager espera
function chaveParaBytes(base64) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const bruto = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...bruto].map((c) => c.charCodeAt(0)));
}

async function registro() {
  const existente = await navigator.serviceWorker.getRegistration('/');
  if (existente) return existente;
  await navigator.serviceWorker.register('/sw.js');
  return navigator.serviceWorker.ready;
}

/** Situação neste aparelho: 'indisponivel' | 'bloqueado' | 'ativo' | 'inativo'. */
export async function estadoPush() {
  if (!suportaPush()) return 'indisponivel';
  if (Notification.permission === 'denied') return 'bloqueado';
  try {
    const reg = await navigator.serviceWorker.getRegistration('/');
    const inscricao = reg && (await reg.pushManager.getSubscription());
    return inscricao && Notification.permission === 'granted' ? 'ativo' : 'inativo';
  } catch (e) {
    return 'inativo';
  }
}

/** Pede a permissão e ativa o push neste aparelho. Retorna { ok, message? }. */
export async function ativarPush() {
  if (!suportaPush()) return { ok: false, message: 'Este navegador não recebe notificações. No iPhone, instale o app na tela de início primeiro.' };
  try {
    const { data } = await api.get('push/chave');
    if (!data.disponivel || !data.chavePublica) return { ok: false, message: 'As notificações no aparelho estão desativadas pela diretoria no momento.' };
    const permissao = await Notification.requestPermission();
    if (permissao !== 'granted') return { ok: false, message: 'Permissão negada. Libere as notificações nas configurações do navegador.' };
    const reg = await registro();
    const inscricao =
      (await reg.pushManager.getSubscription()) ||
      (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: chaveParaBytes(data.chavePublica) }));
    await api.post('push/inscricoes', { subscription: inscricao.toJSON() });
    try { localStorage.removeItem(CHAVE_RECUSA); } catch (e) { /* ignore */ }
    return { ok: true };
  } catch (error) {
    return { ok: false, message: error.response?.data?.error || 'Não foi possível ativar as notificações neste aparelho.' };
  }
}

/** Desativa o push neste aparelho (cancela a inscrição e avisa a API). */
export async function desativarPush() {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/');
    const inscricao = reg && (await reg.pushManager.getSubscription());
    if (inscricao) {
      await api.post('push/inscricoes/remover', { endpoint: inscricao.endpoint }).catch(() => {});
      await inscricao.unsubscribe();
    }
    return { ok: true };
  } catch (error) {
    return { ok: false, message: 'Não foi possível desativar as notificações neste aparelho.' };
  }
}

// Mantém a API atualizada quando o navegador já tem a inscrição (ex.: após novo login no mesmo aparelho)
export async function sincronizarPush() {
  try {
    if ((await estadoPush()) !== 'ativo') return;
    const reg = await navigator.serviceWorker.getRegistration('/');
    const inscricao = await reg.pushManager.getSubscription();
    if (inscricao) await api.post('push/inscricoes', { subscription: inscricao.toJSON() });
  } catch (e) {
    // ignore
  }
}

export function pushRecusadoRecentemente() {
  try {
    const em = Number(localStorage.getItem(CHAVE_RECUSA) || 0);
    return Boolean(em && Date.now() - em < ESPERA_RECUSA);
  } catch (e) {
    return false;
  }
}

export function marcarPushRecusado() {
  try { localStorage.setItem(CHAVE_RECUSA, String(Date.now())); } catch (e) { /* ignore */ }
}
